export const FETCH_TOURNAMENT_REQUEST           = 'FETCH_TOURNAMENT_REQUEST';
export const FETCH_TOURNAMENT_SUCCESS           = 'FETCH_TOURNAMENT_SUCCESS';
export const FETCH_TOURNAMENT_FAILURE           = 'FETCH_TOURNAMENT_FAILURE';

export const FETCH_TOURNAMENT_STANDINGS_REQUEST = 'FETCH_TOURNAMENT_STANDINGS_REQUEST';
export const FETCH_TOURNAMENT_STANDINGS_SUCCESS = 'FETCH_TOURNAMENT_STANDINGS_SUCCESS';
export const FETCH_TOURNAMENT_STANDINGS_FAILURE = 'FETCH_TOURNAMENT_STANDINGS_FAILURE';
